import Auth from './auth.js'
import Api from './lib/api.js';
import DlgPrivacy from './lib/privacy.js'
import IVPLoader from './lib/loader.js'
import FillaAttachmentA from './allegato_a_fn.js'


document.addEventListener("DOMContentLoaded",async()=>{

    document.querySelector("#sidebar-menu .contractors").classList.add("active")
    document.querySelector(".navbar-header .breadcrumb").append($(`<li class="breadcrumb-item active">Contractors</li>`)[0])

    IVPLoader.Show()

    if (await Auth.Init() == false)
        return

    if (Auth.user.privacy_accepted == false)
        await DlgPrivacy.EnsureAccepted()

    // Default Datatable
    let resp = await Api.GetContractors()
    let btb = $('#basic-datatable').DataTable({
        "pageLength": 50,
        "language": {
            "paginate": {
                "previous": "<i class='mdi mdi-chevron-left'>",
                "next": "<i class='mdi mdi-chevron-right'>"
            },
            processing:     "Elaborazione dati...",
            search:         "Ricerca&nbsp;:",
            lengthMenu:    "Visualizza _MENU_ record",
            info:           "Visualizzati da _START_ a _END_ di _TOTAL_ record",
            infoEmpty:      "Nessun record in archivio",
            infoFiltered:   "(trovati su _MAX_ in totale)",
            infoPostFix:    "",
            loadingRecords: "Caricamento dati...",
            zeroRecords:    "Nessun record",
            emptyTable:     "Archivio vuoto",
            sortAscending:  ": activer pour trier la colonne par ordre croissant",
            sortDescending: ": activer pour trier la colonne par ordre décroissant"
        },
       /* 
        "name": "AYME GROUP SRL",
        "address": "Viale Abruzzi 13/A  ",
        "zip": "20131",
        "city": "MILANO",
        "province": "MI",
        "vat": "10721330966",
        "email": "aymegroupsrl2019@gmail.com",
        "pec": "aymegroupsrl@pec.it",
        "phone": "393425017635",
        "iban": "IT46P0760111700001061575989",
        "sdi_code": "N92GLON",
        "auth_id": 54,
        "privacy_accepted": null,
        "login": "aymegroupsrl@pec.it",
        "secret": "12345"
        */
        columns: [                        
            { title: 'Nome', data: 'name' },
            { title: 'Indirizzo', data: 'address' },
            { title: 'Città', data: 'city' },
            //{ title: 'Cap', data: 'zip' },
            //{ title: 'Importo', data: 'amount' },          
            { title: 'Telefono', data: 'phone' },
            //{ title: 'Email', data: 'email' },
            { title: 'Login', data: 'login' },
            { title: 'Pratiche totali', data: 'yards_total_count' },
            { title: 'Pratiche non iniziate', data: 'yards_empty_count' },
            { title: 'Pratiche in lavorazione', data: 'yards_started_count' },
            { title: 'Pratiche approvate', data: 'yards_approved_count' },
            { title: 'Revisore', data: '' },            
            { title: 'Allegato A', data: '' },
            { title: ' ', data: '' },
        ],
        columnDefs: [
            {   
                targets: [-1],
                render: function (data, type, row) {
                    return `<button type='button' class='btnEdit btn btn-outline-secondary btn-sm'>Modifica</button>`
                },
                
            },
            {   
                targets: [-2],
                render: function (data, type, row) {                    
                    let disabled = ""
                    if (row.yards_approved_count == 0)
                        disabled = "disabled"
                    return `<button type='button' class='btnAllegatoA btn btn-outline-secondary btn-sm ${disabled}' ${disabled}>Genera</button>`
                },
                
            },      
            {   
                targets: [-3],
                render: function (data, type, row) {                                        
                    if (row.reviewer_id != null)
                        return `Assegnato`
                    return ``
                },
                
            },                        
        ],
        data: resp,
        buttons: [
            'excel', {
                extend: 'pdfHtml5',
                orientation: 'landscape',
                pageSize: 'A4',
                exportOptions: {
                    columns: ':not(:last-child)',
                },
                footer: true 
            }
        ],
        drawCallback: function () {
            var api = this.api();
            $("#basic-datatable tfoot .yards_total_count").html(api.column( 5, {page:'current'} ).data().sum())
            $("#basic-datatable tfoot .yards_empty_count").html(api.column( 6, {page:'current'} ).data().sum())
            $("#basic-datatable tfoot .yards_started_count").html(api.column( 7, {page:'current'} ).data().sum())
            $("#basic-datatable tfoot .yards_approved_count").html(api.column( 8, {page:'current'} ).data().sum())
        },
        initComplete: function () {
            var api = this.api();
            let f = $('<tfoot/>')
            f.append($(`<th colspan="5">&nbsp</th>`))
            f.append($(`<th class="yards_total_count">0</th>`))
            f.append($(`<th class="yards_empty_count">0</th>`))
            f.append($(`<th class="yards_started_count">0</th>`))
            f.append($(`<th class="yards_approved_count">0</th>`))
            f.append($(`<th>&nbsp</th>`))

            $("#basic-datatable").append(f)
            api.table().draw()
        }        
    });
    btb.buttons().container()
    .appendTo($("#table-buttons"))
    

    let fnUpdateButtons = ()=> {
        $("#basic-datatable .btnEdit").off('click')
        $("#basic-datatable .btnEdit").click((e)=>{
            let tr = btb.row(e.target.closest('tr'))
            document.location.href = "contractor.html?id="+tr.data().id            
        })

        $("#basic-datatable .btnAllegatoA").off('click')
        $("#basic-datatable .btnAllegatoA").click( async (e)=>{
            IVPLoader.Show()
            try {
                let tr = btb.row(e.target.closest('tr'))
                let contractor_id = tr.data().id
                //await FillaAttachmentA(contractor_id)            
                window.open('allegato_a.html?id='+contractor_id, '_blank');
            }
            catch (Ex) {
                console.error(Ex)
            }
            IVPLoader.Remove()
        })        
    }

    fnUpdateButtons()
    
    btb.on( 'draw init.dt', fnUpdateButtons)

    document.querySelector(".page-content").classList.remove("hidden")

    IVPLoader.Remove()
})